export const PersianInformalWithEmoji = [
  {
    sentence:
      "بالاخره دوره {COURSE_TITLE} رو توی فرادرس تموم کردم و گواهینامه‌ام رو گرفتم! 🎉📜",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "دوره {COURSE_TITLE} رو در فرادرس گذروندم و گواهینامه‌اش رو هم گرفتم! 🎓💪",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "دوره {COURSE_TITLE} رو توی فرادرس تموم کردم و حالا گواهینامه‌ام دستمه! 📜🥳",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "خیلی خوشحالم که دوره {COURSE_TITLE} رو گذروندم و گواهینامه‌ام رو گرفتم. 💥🌟",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "بعد از گذروندن دوره {COURSE_TITLE} در فرادرس، گواهینامه‌ام رو هم دریافت کردم. 🎉📝",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "موفق شدم دوره {COURSE_TITLE} رو تو فرادرس بگذرونم و گواهینامه بگیرم! 🎓✨",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence: "دوره {COURSE_TITLE} رو تموم کردم و گواهینامه‌اش رو گرفتم! 🏆🎖️",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "خوشحالم که تونستم دوره {COURSE_TITLE} رو تو فرادرس بگذرونم و گواهینامه‌ام رو بگیرم. 📜😊",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "دوره {COURSE_TITLE} در فرادرس رو گذروندم و بالاخره گواهینامه‌اش رو گرفتم! 🎓💫",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "تونستم دوره {COURSE_TITLE} رو در فرادرس تموم کنم و گواهینامه‌اش رو بگیرم! 🏅📜",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "دوره {COURSE_TITLE} رو توی فرادرس گذروندم و گواهینامه گرفتم! 🎉🎖️",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "دوره {COURSE_TITLE} رو تموم کردم و گواهینامه فرادرس رو گرفتم! 🥇📜",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "دوره {COURSE_TITLE} رو در فرادرس گذروندم و گواهینامه‌اش دستمه. 🎓😎",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "بالاخره تونستم دوره {COURSE_TITLE} رو بگذرونم و گواهینامه‌اش رو بگیرم. 🌟📄",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "موفق شدم دوره {COURSE_TITLE} رو در فرادرس تموم کنم و گواهینامه بگیرم! 🎓🎉",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "بالاخره یکی از دوره‌های فرادرس رو تموم کردم و گواهینامه‌اش رو گرفتم! 🎉📜",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "یکی از دوره‌های فرادرس رو گذروندم و گواهینامه‌اش رو هم گرفتم! 🎓💪",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence: "دوره‌ای از فرادرس رو تموم کردم و حالا گواهینامه‌ام دستمه! 📜🥳",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "خیلی خوشحالم که یکی از دوره‌های فرادرس رو گذروندم و گواهینامه‌ام رو گرفتم. 💥🌟",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "بعد از گذروندن یکی از دوره‌های فرادرس، گواهینامه‌ام رو هم دریافت کردم. 🎉📝",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "موفق شدم یکی از دوره‌های فرادرس رو بگذرونم و گواهینامه بگیرم! 🎓✨",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "یکی از دوره‌های فرادرس رو تموم کردم و گواهینامه‌اش رو گرفتم! 🏆🎖️",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "خوشحالم که تونستم یکی از دوره‌های فرادرس رو بگذرونم و گواهینامه‌ام رو بگیرم. 📜😊",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "یک دوره در فرادرس رو گذروندم و بالاخره گواهینامه‌اش رو گرفتم! 🎓💫",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "تونستم یکی از دوره‌های فرادرس رو تموم کنم و گواهینامه‌اش رو بگیرم! 🏅📜",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence: "یکی از دوره‌های فرادرس رو گذروندم و گواهینامه گرفتم! 🎉🎖️",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence: "یک دوره فرادرس رو تموم کردم و گواهینامه فرادرس رو گرفتم! 🥇📜",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence: "یکی از دوره‌های فرادرس رو گذروندم و گواهینامه‌اش دستمه. 🎓😎",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "بالاخره تونستم یکی از دوره‌های فرادرس رو بگذرونم و گواهینامه‌اش رو بگیرم. 🌟📄",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "موفق شدم یکی از دوره‌های فرادرس رو تموم کنم و گواهینامه بگیرم! 🎓🎉",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
];
